import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { itemService } from '../services/itemService';
import { ItemInput } from '../types/item';

const ITEMS_KEY = ['items'];

export function useItems() {
  return useQuery({ queryKey: ITEMS_KEY, queryFn: itemService.list });
}

export function useCreateItem() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: ItemInput) => itemService.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ITEMS_KEY }),
  });
}

export function useDeleteItem() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => itemService.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ITEMS_KEY }),
  });
}
